/** localStorage 键：跨标签页广播 Web 端登出（Cookie SSO 场景） */
export const AUTH_LOGOUT_STORAGE_KEY = 'hs:auth-logout';

/** sessionStorage：本标签页正在登出，避免 RouteGuard 抢先跳转登录页 */
export const AUTH_LOGGING_OUT_SESSION_KEY = 'hs:auth-logging-out';

export function markAuthLoggingOut(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(AUTH_LOGGING_OUT_SESSION_KEY, '1');
  } catch {
    // ignore
  }
}

export function clearAuthLoggingOut(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(AUTH_LOGGING_OUT_SESSION_KEY);
  } catch {
    // ignore
  }
}

export function isAuthLoggingOut(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(AUTH_LOGGING_OUT_SESSION_KEY) === '1';
}

export function broadcastAuthLogout(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(AUTH_LOGOUT_STORAGE_KEY, String(Date.now()));
  } catch {
    // ignore quota / private mode
  }
}

export function isAuthLogoutStorageEvent(key: string | null): boolean {
  return key === AUTH_LOGOUT_STORAGE_KEY;
}
